import { createSelector } from 'reselect';

import { createSelectorFactory } from 'wanderu-ducks-utils';

import { serializePredictionParams } from '../actions/utils';
import SLICE_NAMESPACE from '../types';
import NAMESPACE from './types';

function _dataSelector(state) {
    return state[SLICE_NAMESPACE][NAMESPACE];
}

function _predictionSelector(data, id) {
    return data.predictions[id];
}

function _topPredictionSelector(predictions = []) {
    return predictions[0];
}

function _placeDetailsSelector(data, placeId) {
    return data.placeDetails[placeId];
}

function selectPlaceDetailsFactory(placeId) {
    return createSelector(
        _dataSelector,
        (state) => _placeDetailsSelector(state, placeId),
    );
}
const selectPlaceDetails = createSelectorFactory(selectPlaceDetailsFactory);

function selectPredictionsFactory(id) {
    return createSelector(
        _dataSelector,
        (state) => _predictionSelector(state, id),
    );
}
const _selectPredictions = createSelectorFactory(selectPredictionsFactory);

function selectPredictions(appState, predictionParams) {
    const id = serializePredictionParams(predictionParams);
    return _selectPredictions(appState, id);
}

function selectTopPredictionFactory(id) {
    return createSelector(
        (state) => _selectPredictions(state, id),
        _topPredictionSelector,
    );
}
const _selectTopPrediction = createSelectorFactory(selectTopPredictionFactory);

function selectTopPrediction(appState, predictionParams) {
    const id = serializePredictionParams(predictionParams);
    return _selectTopPrediction(appState, id);
}

const selectLatLongData = createSelector(
    selectPlaceDetails,
    (place) => ({
        latitude: place?.geometry?.location?.lat,
        longitude: place?.geometry?.location?.lng,
    }),
);

export {
    selectLatLongData,
    selectPlaceDetails,
    selectPredictions,
    selectTopPrediction,
};
